import { render, staticRenderFns } from "./Surprise.vue?vue&type=template&id=07e47ae6&scoped=true&"
import script from "./Surprise.vue?vue&type=script&lang=ts&"
export * from "./Surprise.vue?vue&type=script&lang=ts&"
import style0 from "./Surprise.vue?vue&type=style&index=0&id=07e47ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e47ae6",
  null
  
)

export default component.exports